// extracted by mini-css-extract-plugin
export default {"blue":"#00a9e0","card":"Simple_card__xrjDi","avatar":"Simple_avatar__6Pzgb"};